import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Swords, Ticket, ChevronRight } from "lucide-react";
import { api } from "@/lib/api";

export function GamesFeedCard({ prefix = "" }) {
  const [duels, setDuels] = useState([]);
  const [scratch, setScratch] = useState(null);
  useEffect(() => {
    api.get("/duels").then(({ data }) => setDuels(data.filter((d) => d.status === "pending" && d.incoming))).catch(() => {});
    api.get("/scratch").then(({ data }) => setScratch(data)).catch(() => {});
  }, []);
  if (!scratch && !duels.length) return null;
  const left = scratch ? scratch.daily_limit - scratch.bought_today : 0;
  return (
    <div className="rounded-3xl bg-white border border-pink-100 p-4 space-y-2.5" data-testid={`${prefix}feed-games-card`}>
      <p className="text-xs font-extrabold uppercase tracking-widest text-rose-500">Spiele</p>
      {duels.slice(0, 2).map((d) => (
        <Link key={d.id} to="/spiele" data-testid={`${prefix}feed-duel-invite-${d.id}`} className="flex items-center gap-3 rounded-2xl bg-gradient-to-r from-violet-50 to-pink-50 p-3 hover:from-violet-100 transition-colors">
          <span className="w-9 h-9 shrink-0 rounded-xl bg-gradient-to-br from-violet-500 to-pink-500 flex items-center justify-center animate-pulse"><Swords className="w-4 h-4 text-white" /></span>
          <span className="flex-1 min-w-0 text-sm"><b className="block truncate">{d.other.name}</b><span className="text-slate-500">fordert dich heraus · {d.stake} Punkte</span></span>
          <ChevronRight className="w-4 h-4 text-slate-400" />
        </Link>
      ))}
      {duels.length > 2 && <Link to="/spiele" className="block text-xs font-bold text-rose-600">+{duels.length - 2} weitere Herausforderungen</Link>}
      {scratch && left > 0 && (
        <Link to="/spiele" data-testid={`${prefix}feed-scratch-hint`} className="flex items-center gap-3 rounded-2xl bg-gradient-to-r from-amber-50 to-pink-50 p-3 hover:from-amber-100 transition-colors">
          <span className="w-9 h-9 shrink-0 rounded-xl bg-gradient-to-br from-amber-300 to-pink-500 flex items-center justify-center"><Ticket className="w-4 h-4 text-white" /></span>
          <span className="flex-1 min-w-0 text-sm"><b className="block">Rubbellos ziehen</b><span className="text-slate-500">Bis zu {scratch.max_prize} Punkte · noch {left} heute</span></span>
          <ChevronRight className="w-4 h-4 text-slate-400" />
        </Link>
      )}
    </div>
  );
}
